(function (Drupal, once) {
  Drupal.behaviors.monthlyPartsVsLaborChart = {
    attach(context) {

      const canvas = once(
        'monthly-parts-vs-labor',
        '#monthly-parts-vs-labor-chart',
        context
      )[0];

      if (!canvas) return;

      let labels = [];
      let parts = [];
      let operations = [];

      try {
        labels = JSON.parse(canvas.dataset.labels || '[]');
        parts = JSON.parse(canvas.dataset.parts || '[]');
        operations = JSON.parse(canvas.dataset.operations || '[]');
      } catch (e) {
        console.warn('Invalid monthly chart data', e);
        return;
      }

      new Chart(canvas, {
        type: 'bar',
        data: {
          labels,
          datasets: [
            {
              label: 'Части',
              data: parts,
              backgroundColor: '#17c1e8',
              borderRadius: 4,
            },
            {
              label: 'Труд',
              data: operations,
              backgroundColor: '#fb8c00',
              borderRadius: 4,
            }
          ]
        },
        options: {
          responsive: true,
          interaction: {
            intersect: false,
            mode: 'index',
          },
          indexAxis: 'x',
          plugins: {
            legend: {
              position: 'top',
            },
            tooltip: {
              callbacks: {
                label(context) {
                  return `${context.dataset.label}: ${context.parsed.y.toFixed(2)} €`;
                }
              }
            }
          },
          scales: {
            y: {
              beginAtZero: true,
            }
          }
        }
      });
    }
  };
})(Drupal, once);
